import {
  DialogInteractOutsideEvent,
  DrawerRoot,
  DrawerRootProps,
} from '@chakra-ui/react';
import { useCallback } from 'react';
import { ignoreParentLayerDismiss, isToastInteraction } from './Overlays';

/**
 * Chakra's `Drawer.Root`, except closing a toast over the drawer isn't an
 * interaction outside it: zag doesn't dismiss the drawer, and a caller's
 * `onInteractOutside` (several close the drawer from it) isn't called.
 *
 * Drawers run zag's dialog machine, so like `MCenterModal` they also ignore
 * zag's dismiss cascade: a drawer opened from a select or popover item stays
 * open when that popover closes (see ./Overlays/ignoreParentLayerDismiss).
 */
const MDrawer = ({ onInteractOutside, ...rest }: DrawerRootProps) => {
  const handleInteractOutside = useCallback(
    (event: DialogInteractOutsideEvent) => {
      if (isToastInteraction(event)) {
        event.preventDefault();
        return;
      }
      onInteractOutside?.(event);
    },
    [onInteractOutside],
  );

  return (
    <DrawerRoot
      onInteractOutside={handleInteractOutside}
      onRequestDismiss={ignoreParentLayerDismiss}
      {...rest}
    />
  );
};

export default MDrawer;
